import { lazyWithRetry } from '../app/lazyWithRetry';

export const Login = lazyWithRetry(() => import('../pages/Login'));
export const LoginLocal = lazyWithRetry(() => import('../pages/LoginLocal'));
export const Forbidden = lazyWithRetry(() => import('../pages/Forbidden'));
export const Admin = lazyWithRetry(() => import('../pages/Admin'));
export const AdminDashboard = lazyWithRetry(() => import('../pages/AdminDashboard'));
export const Profile = lazyWithRetry(() => import('../pages/Profile'));
export const UserDetail = lazyWithRetry(() => import('../pages/UserDetail'));
export const UserDashboard = lazyWithRetry(() => import('../pages/UserDashboard'));
export const ClassroomsList = lazyWithRetry(() => import('../pages/ClassroomsList'));
export const ClassroomDetail = lazyWithRetry(() => import('../pages/ClassroomDetail'));
export const ContentSources = lazyWithRetry(() => import('../pages/ContentSources'));
export const ContentSourceDetail = lazyWithRetry(() => import('../pages/ContentSourceDetail'));
export const ContentActivities = lazyWithRetry(() => import('../pages/ContentActivities'));
export const StudentsList = lazyWithRetry(() => import('../pages/StudentsList'));
export const StudentsProgress = lazyWithRetry(() => import('../pages/StudentsProgress'));
export const Settings = lazyWithRetry(() => import('../pages/Settings'));
export const ClassroomCreate = lazyWithRetry(() => import('../pages/ClassroomCreate'));
export const AssignmentCreate = lazyWithRetry(() => import('../pages/AssignmentCreate'));
export const AssignmentEdit = lazyWithRetry(() => import('../pages/AssignmentEdit'));
export const AssignmentDetail = lazyWithRetry(() => import('../pages/AssignmentDetail'));
export const AssignmentItemDetail = lazyWithRetry(() => import('../pages/AssignmentItemDetail'));
export const StudentPracticeDetail = lazyWithRetry(() => import('../pages/StudentPracticeDetail'));
export const AdminUsers = lazyWithRetry(() => import('../pages/AdminUsers'));
export const AdminUserAccountLink = lazyWithRetry(() => import('../pages/AdminUserAccountLink'));
export const AdminUserAccountLinkDetail = lazyWithRetry(
  () => import('../pages/AdminUserAccountLinkDetail'),
);
export const AdminRoles = lazyWithRetry(() => import('../pages/AdminRoles'));
export const AdminSystem = lazyWithRetry(() => import('../pages/AdminSystem'));
export const AdminAiConfig = lazyWithRetry(() => import('../pages/AdminAiConfig'));
export const AdminMaterializedViews = lazyWithRetry(
  () => import('../pages/AdminMaterializedViews'),
);
export const AdminTtsAudioCache = lazyWithRetry(() => import('../pages/AdminTtsAudioCache'));
export const AuditLogs = lazyWithRetry(() => import('../pages/AuditLogs'));
export const AdminErrorLogs = lazyWithRetry(() => import('../pages/AdminErrorLogs'));
export const AdminFeTelemetryLogs = lazyWithRetry(() => import('../pages/AdminFeTelemetryLogs'));
export const MyClassrooms = lazyWithRetry(() => import('../pages/MyClassrooms'));
export const PublicResources = lazyWithRetry(() => import('../pages/PublicResources'));
export const IndexedDocuments = lazyWithRetry(() => import('../pages/IndexedDocuments'));
export const StudentClassroomDetail = lazyWithRetry(
  () => import('../pages/StudentClassroomDetail'),
);
export const StudentAssignmentDetail = lazyWithRetry(
  () => import('../pages/StudentAssignmentDetail'),
);
export const WorksheetAttemptPage = lazyWithRetry(
  () => import('../features/worksheet/student/WorksheetAttemptPage'),
);
export const WorksheetAttemptReviewPage = lazyWithRetry(
  () => import('../features/worksheet/student/WorksheetAttemptReviewPage'),
);
export const StudentSubmission = lazyWithRetry(() => import('../pages/StudentSubmission'));
export const StudentMultiChoicePractice = lazyWithRetry(
  () => import('../pages/StudentMultiChoicePractice'),
);
export const StudentNameManagement = lazyWithRetry(() => import('../pages/StudentNameManagement'));
export const SessionDetail = lazyWithRetry(() => import('../pages/SessionDetail'));
export const StudentSubmissions = lazyWithRetry(() => import('../pages/StudentSubmissions'));
export const StudentClassrooms = lazyWithRetry(() => import('../pages/StudentClassrooms'));
export const ExerciseLibrary = lazyWithRetry(() => import('../pages/ExerciseLibrary'));
export const TemplateDetail = lazyWithRetry(() => import('../pages/TemplateDetail'));
export const PreviewPractice = lazyWithRetry(() => import('../pages/PreviewPractice'));
export const Notifications = lazyWithRetry(() => import('../pages/Notifications'));
